import { render } from "./ModalDetalleDevoluciones.vue?vue&type=template&id=124eca77&scoped=true"
import script from "./ModalDetalleDevoluciones.vue?vue&type=script&lang=js"
export * from "./ModalDetalleDevoluciones.vue?vue&type=script&lang=js"

import "./ModalDetalleDevoluciones.vue?vue&type=style&index=0&id=124eca77&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124eca77"]])

export default __exports__